import { NgForOf, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { Account } from '@core/auth/account.model';

import { AccountService } from '@core/auth/account.service';
import { LoginService } from '@core/login/login.service';
import { PersonService } from '@core/user/person.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { HomePageDTO } from '@model/homepage-dto.model';
import { IProgramNews } from '@model/program-news.model';
import { TranslateService } from '@ngx-translate/core';
import { ProgramNewsService } from '@programs/program-news/program-news.service';

@Component({
  selector: 'jhi-home',
  templateUrl: './home.component.html',
  imports: [RouterLink, FontAwesomeModule, NgIf, NgForOf],
  standalone: true,
})
export class HomeComponent implements OnInit {
  account?: Account | null;
  currentLanguage: string | undefined;
  homeInfo?: HomePageDTO;
  protected readonly faExternalLinkAlt = faExternalLinkAlt;

  constructor(
    private accountService: AccountService,
    protected personService: PersonService,
    private translateService: TranslateService,
    private programNewsService: ProgramNewsService,
    private loginService: LoginService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.accountService.identity().subscribe(account => (this.account = account));
    this.currentLanguage = this.translateService.currentLang;
    this.programNewsService.newsHomepage().subscribe(res => {
      this.homeInfo = res.body || undefined;
    });
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  login(): void {
    this.loginService.login();
  }

  getDescription(text?: string): SafeHtml {
    if (text && text.length > 200) {
      return this.sanitizer.bypassSecurityTrustHtml(text.substring(0, 200));
    }

    return this.sanitizer.bypassSecurityTrustHtml(text ?? '');
  }

  hasNews(): boolean | undefined {
    return this.homeInfo && this.homeInfo.news && this.homeInfo.news.length > 0;
  }

  getNewsDescription(news: IProgramNews): string {
    if (news && news.descriptionPT) {
      return news.descriptionPT.replace(/<[^>]*>/g, '');
    }
    return '';
  }
}
